/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { classnames as cx } from '@ba-ui-toolkit/utils';
import HSpacer from '@ba-ui-toolkit/hspacer';

import styles from './ToolbarFactory.scss';

const $toolbarClassName = styles.ToolbarWidget.replace(/"/g, '');

function Separator(props) {
	const { width } = props;
	const style = {
		width,
	};

	return <span style={style} className={`${$toolbarClassName}__separator`} />;
}
Separator.propTypes = {
	width: PropTypes.number,
};

const ToolbarFactory = options => {
	class ToolbarWidget extends Component {
		static propTypes = {
			children: PropTypes.node,
			onToolbarChange: PropTypes.func,
			border: PropTypes.string,
			// onJason: PropTypes.func,
		};

		static defaultPropTypes = {
			onToolbarChange: () => {},
		};

		static Separator = Separator;

		static Spacer = HSpacer;

		state = {
			toggle: false,
		};

		render() {
			const {
				// react
				children,
				// bool
				border,
				// cbFunc
				onToolbarChange,
			} = this.props;

			return (
				<div className={cx($toolbarClassName, { border })}>
					{React.Children.map(children, (child, i) => {
						if (!child) {
							return false;
						}
						if (child.type && child.type.displayName === 'Separator') {
							return child;
						}
						const cloneProps = {};
						// TODO: add customized condition here
						if (
							child.type.displayName === 'ContextMenu' ||
							child.type.name === 'ContextMenu'
						) {
							cloneProps.onChange = (name, values) => {
								onToolbarChange && onToolbarChange(child.props.name, values);
							};
						}
						if (child.type.displayName === 'Button' || child.type.name === 'Button') {
							cloneProps.onClick = () => {
								if (!child.props.toggle) {
									onToolbarChange &&
										onToolbarChange(child.props.name, child.props.value);
								} else {
									onToolbarChange &&
										onToolbarChange(child.props.name, !this.state.toggle);
									this.setState({ toggle: !this.state.toggle });
								}
							};
						}

						return (
							<span className={`${$toolbarClassName}__item`} key={i}>
								{React.cloneElement(child, {
									...cloneProps,
								})}
							</span>
						);
					})}
				</div>
			);
		}
	}

	options.forEach(option => {
		ToolbarWidget[option.name] = option.model;
	});

	return ToolbarWidget;
};

export default ToolbarFactory;
